import React from 'react';
import { Eye } from 'lucide-react';

interface SecondaryButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  text: string;
  className?: string;
  Icon?: React.ElementType | null;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  text,
  className,
  Icon = Eye,
}) => {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-2 border rounded-xl shadow flex items-center text-md ${className ?? 'hover:bg-gray-100'}`}
    >
      {Icon && <Icon size={16} className="mr-2" />}
      {text}
    </button>
  );
};

export default SecondaryButton;
